<template>
  <div
    data-test="graphics-socialDataMapper"
  >
    <ul
      v-if="controlType === 'button'"
      data-test="graphics-socialDataMapper-list"
    >
      <li
        v-for="(prop, key, index) in choices[choiceType]"
        :key="index + choiceType + dataProvider.id"
        class="sidebar__data-selector-option flex"
        :data-test="`graphics-socialDataMapper-select-${key}`"
        data-entity="graphics-socialDataMapper-select"
        @click="mapField(key)"
      >
        {{ prop }}
      </li>
    </ul>
    <select
      v-if="controlType === 'select'"
      v-model="dataPointSelected"
      :name="selectName"
      :data-test="`graphics-socialDataMapper-selectDataPoint-${choiceType}`"
      :data-entity="`graphics-socialDataMapper-selectDataPoint-${choiceType}`"
    >
      <option
        v-for="(prop, key, index) in choices[choiceType]"
        :key="index + choiceType + dataProvider.id"
        :value="key"
        :data-test="`graphics-socialDataMapper-selectDataPoint-${key}`"
      >
        {{ prop }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  emits: ['update-map'],
  name: 'SocialMapper',
  props: {
    dataProvider: {
      type: Object,
      required: true,
    },
    property: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Object],
      default: '',
    },
    controlType: {
      type: String,
      default: 'button',
    },
    selectName: {
      type: String,
      default: '',
    },
    dataType: {
      type: String,
      default: null,
    },
  },
  computed: {
    choiceType() {
      if (this.dataType === 'social-network-attribution') {
        return 'icons';
      }
      if (['color', 'textShadowColor', 'backgroundColor', 'gradientColorOne', 'gradientColorTwo', 'borderColor', 'boxShadowColor'].includes(this.property)) {
        return 'color';
      }
      if (['imageUrl', 'backgroundImageUrl'].includes(this.property)) {
        return 'image';
      }
      return this.property;
    },
    dataPointSelected: {
      get() {
        return this.value;
      },
      set(value) {
        const data = {
          path: `data.dataKeyMap.${this.property}`,
          value,
          property: this.property,
        };
        this.$emit('update-map', data);
      },
    },
    choices() {
      return {
        text: {
          user_real_name: 'Author',
          user_name: 'Handle',
          html: 'Post Content',
        },
        image: {
          user_profile_image_url: 'Avatar',
          'logos.svg.icons.primary': 'Primary Network Icon',
          'logos.svg.icons.white': 'White Network Icon',
          'logos.svg.icons.black': 'Black Network Icon',
        },
        icons: {
          'logos.svg.icons.primary': 'Primary Network Icon',
          'logos.svg.icons.white': 'White Network Icon',
          'logos.svg.icons.black': 'Black Network Icon',
        },
        src: {
          media: 'Post Media',
        },
        color: {
          'colors.primary': 'Primary Network Color',
          'colors.secondary': 'Secondary Network Color',
        },
      };
    },
  },
  methods: {
    mapField(value) {
      if (!this.dataProvider) return;

      if (this.property === 'src' && value === 'media') {
        // data driven src can be anything and data needs to be mapped to
        // these feilds as well to handle switching all related values
        const dataIsVideo = {
          path: 'data.dataKeyMap.isVideo',
          value,
          property: 'isVideo',
        };

        this.$emit('update-map', dataIsVideo);

        const dataPoster = {
          path: 'data.dataKeyMap.poster',
          value,
          property: 'poster',
        };

        this.$emit('update-map', dataPoster);
      }

      const data = {
        path: `data.dataKeyMap.${this.property}`,
        value,
        property: this.property,
      };

      this.$emit('update-map', data);
    },
  },
};
</script>
